import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

interface OtpHeaderProps {
  className?: string;
  email?: string;
  isDisabled: boolean;
  onCancel: () => void;
}

export const OtpHeader = ({
  className,
  email,
  isDisabled,
  onCancel,
}: OtpHeaderProps) => {
  if (!email) {
    return null;
  }

  return (
    <div
      className={classNames(
        "bg-tertiary -mx-6 -mt-6 mb-4 flex h-12 items-center justify-between rounded-t-lg px-6",
        className,
      )}
    >
      <Typography.BodySm>{email}</Typography.BodySm>
      <button
        type="button"
        className="cursor-pointer text-secondary transition-colors hover:text-primary"
        onClick={onCancel}
        disabled={isDisabled}
        aria-label={t("otp_challenge_modal.cancel")}
        tabIndex={-1}
      >
        <Icon type="20-close" size={20} className="size-5" />
      </button>
    </div>
  );
};

OtpHeader.displayName = "OtpHeader";
